<template>
  <div class="model-chips-container">
    <!-- Show first 2 model chips -->
    <template
      v-if="modelNameTable && modelNameTable !== '' && modelNameTable !== 'All Model'">
      <v-chip v-for="(model, idx) in getModelChips(modelNameTable).slice(0, 2)" :key="idx"
        size="small" variant="tonal" class="model-chip-item">
        {{ model }}
      </v-chip>

      <!-- Show remaining count chip -->
      <v-chip v-if="getModelChips(modelNameTable).length > 2" size="small" class="model-chip-count">
        +{{ getModelChips(modelNameTable).length - 2 }}
      </v-chip>
    </template>

    <!-- Show "All Model" chip -->
    <v-chip v-else-if="modelNameTable === 'All Model'" size="small" variant="tonal"
      class="model-chip-item">
      All Model
    </v-chip>

    <!-- Show dash for empty -->
    <span v-else class="text-grey">-</span>
  </div>
</template>

<script>
// Presentational model-chips table cell shared by ModelQuickGroup and
// ModelQuickReply. Markup and getModelChips() moved verbatim from those views
// (the chips styling comes from the global .model-chips-container /
// .model-chip-item / .model-chip-count rules in assets/styles/globals.css, so
// rendering is unchanged). SetupGroupModel keeps its inline copy because its
// scoped style block overrides those chip classes with different colors.
export default {
  name: "ModelChipsCell",
  props: {
    modelNameTable: {
      type: String,
      default: "",
    },
  },
  methods: {
    getModelChips(modelNameTable) {
      if (!modelNameTable || modelNameTable === '' || modelNameTable === 'All Model') {
        return [];
      }

      return modelNameTable
        .split(', ')
        .map(item => {
          const name = item.split(':')[0].trim();
          return name;
        })
        .filter(name => name !== '');
    },
  },
};
</script>
